import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
// import { Server } from './objects/callServer';
import jQuery from 'jquery';
const $ = jQuery;
const chckWithTick = '/assets/UI/Check-box-with-tick.png';
const chckWithoutTick = '/assets/UI/Check-box-without-tick.png';

export default class SignUp {
  constructor() {
    document
      .querySelector('#submit_btn')
      .addEventListener('click', this.onSubmit.bind(this));
    document
      .querySelector('#checkbox')
      .addEventListener('click', this.onCheckboxClick.bind(this));
    document
      .querySelector('#checkbox2')
      .addEventListener('click', this.onCheckboxClick2.bind(this));
    document
      .querySelector('#checkbox3')
      .addEventListener('click', this.onCheckboxClick3.bind(this));
    document
      .querySelector('#backSignUp_btn')
      .addEventListener('click', this.onBack.bind(this));
    document
      .querySelector('#countryCode')
      .addEventListener('change', this.onChangeCountry.bind(this));
    this.formBool = false;
    this.checkboxBool = false;
    this.checkboxBool2 = false;
    this.checkboxBool3 = false;
  }

  init() {
    this.isChecked = true;
    // Global.serverObj = new Server();
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  onBack() {
    Global.clickUpdater('backSignUp_btn');
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'SignupSignin',
        },
      },
    });
  }

  showScreen(screenKey) {
    if (screenKey != 'SignUp') return false;
    this.pageAnimation();
    Global.countryCode = '';

    document.querySelectorAll('input, select').forEach((el) => {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
      } else {
        el.value = '';
      }
    });

    document.querySelector('#signup_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#submit_btn', { opacity: 0 });
    gsap.fromTo(
      '#signup_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );
    setTimeout(() => {
      // Animate to final position and full opacity

      this.events.dispatchEvent({
        type: 'ANIMATION_EVENTS',
        message: {
          event_type: 'buttonAnimation',
          data: {
            selector: '#submit_btn',
          },
        },
      });
    }, 1000);
  }

  onChangeCountry() {
    Global.country = document.querySelector('#countryCode').value;
    if (Global.country == 'UAE') {
      Global.countryCode = '+971';
    } else if (Global.country == 'KWT') {
      Global.countryCode = '+965';
    } else if (Global.country == 'KSA') {
      Global.countryCode = '+966';
    } else if (Global.country == 'QTR') {
      Global.countryCode = '+974';
    } else if (Global.country == 'BHR') {
      Global.countryCode = '+973';
    }
    document.querySelector('#phoneCode').value = Global.countryCode;
  }

  onSubmit() {
    if (this.formBool) {
      return;
    }
    const firstname = document.getElementById('name').value;
    const mobile = document.getElementById('mobile').value;
    const email = document.getElementById('email').value;
    const country = document.getElementById('countryCode').value;
    const oreoBiscuit = document.getElementById('oreoBiscuit').value;

    const regex =
      /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const name_regx = /^[a-zA-Z ]{2,30}$/;
    const mobile_regx = /^(\+\d{1,3}[- ]?)?\d{8,11}$/;
    if (firstname.length <= 0) {
      showError(Global.language.nameError[Global.lang]);
      Global.signUpError = 'nameError';
      return;
    } else if (email == '' || email == null) {
      showError(Global.language.emailError[Global.lang]);
      Global.signUpError = 'emailError';
      return;
    } else if (!regex.test(email)) {
      showError(Global.language.emailErrorValid[Global.lang]);
      Global.signUpError = 'emailErrorValid';
      return;
    }
    if (country.length <= 0) {
      showError(Global.language.countryError[Global.lang]);
      Global.signUpError = 'countryError';
      return;
    } else if (mobile == '' || mobile == null) {
      showError(Global.language.mobileError[Global.lang]);
      Global.signUpError = 'mobileError';
      return;
    } else if (!mobile_regx.test(mobile)) {
      showError(Global.language.mobileErrorValid[Global.lang]);
      Global.signUpError = 'mobileErrorValid';
    }
    if (oreoBiscuit.length <= 0) {
      showError(Global.language.packError[Global.lang]);
      Global.signUpError = 'packError';
    } else if (!this.checkboxBool3) {
      showError(Global.language.ageError[Global.lang]);
      Global.signUpError = 'ageError';
    } else if (!this.checkboxBool) {
      showError(Global.language.tcError[Global.lang]);
      Global.signUpError = 'tncError';
    } else {
      Global.name = firstname;
      Global.email = email;
      Global.mobile = Global.countryCode + mobile;
      Global.country = country;
      Global.pack = oreoBiscuit;

      // console.log(Global.U_ID);
      this.formBool = true;

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const tempData = null;
      let ga_cid = '1844306653.1689247851';
      ga_cid = getCookie2('_ga');

      if (typeof ga_cid === 'undefined' || ga_cid === null) {
        ga_cid = '1844306653.1689247851';
      }

      const utm_term = urlParams.get('utm_term');
      const utm_medium = urlParams.get('utm_medium');
      const utm_source = urlParams.get('utm_source');
      const utm_campaign = urlParams.get('utm_campaign');
      const utm_content = urlParams.get('utm_content');
      // window.htk = "s";
      window.htk = getCookie('hubspotutk');

      function getCookie(cookie) {
        return document.cookie.split(';').reduce((prev, c) => {
          const arr = c.split('=');
          return arr[0].trim() === cookie ? arr[1] : prev;
        }, undefined);
      }

      function getCookie2(cname) {
        const name = `${cname}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        // console.log(name);
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      }

      Global.serverObj.send(
        `${Global.BASE_URL}login.php`,
        (response) => {
          response = JSON.parse(response);

          this.formBool = false;

          if (response.code == 200) {
            Global.loginStatus = true;
            // Global.U_ID = response.uid;
            // Global.gameKey = response.gameKey;
            // Global.name = response.name;
            // Global.email = response.email;
            // Global.mobile = response.mobile;
            // Global.country = response.country;
            // Global.pack = response.pack;
            Global.clickUpdater('submit_btn');
            localStorage.setItem('U_ID', Global.U_ID);
            localStorage.setItem('name', Global.name);
            localStorage.setItem('email', Global.email);
            localStorage.setItem('gameKey', Global.gameKey);
            localStorage.setItem('mobile', Global.mobile);
            localStorage.setItem('country', Global.country);
            localStorage.setItem('pack', Global.pack);
            localStorage.setItem('click_id', Global.click_id);
            Global.gameTry = 0;
            localStorage.setItem('gameTry', Global.gameTry);

            document.querySelector('#homeBtn').classList.add('active');
            fbq('track', 'CompleteRegistration');
            snaptr('track', 'SIGN_UP');
            ttq.instance('D19B76BC77U3RR3TQU8G').track('CompleteRegistration');
            gtag('event', 'conversion', {
              allow_custom_scripts: true,
              u1: 'https://www.oreostayplayful.com/',
              u5: '[User Market]',
              send_to: 'DC-9227341/oreo-003/engag0+standard',
            });
            document.getElementById('nscript').innerHTML =
              '<img src="https://ad.doubleclick.net/ddm/activity/src=9227341;type=oreo-003;cat=engag0;u1=https://www.oreostayplayful.com/;u5=' +
              Global.country +
              ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>';
            if (Global.expType == 'vote') {
              this.events.dispatchEvent({
                type: 'LOADER_EVENTS',
                message: {
                  event_type: 'switch_page',
                  data: {
                    screenKey: 'show_leader',
                  },
                },
              });
            } else {
              this.events.dispatchEvent({
                type: 'LOADER_EVENTS',
                message: {
                  event_type: 'switch_page',
                  data: {
                    screenKey: 'show_selection',
                  },
                },
              });
            }
          } else if (response.code == 400) {
            // showError(response.message);
            $('.errorBox').hide();
            $('.signupError').show();
            document.querySelector('#error_scr').style.display = 'flex';
            gsap.set('#error_scr .biscuit1', { x: -200, opacity: 0 });
            gsap.set('#error_scr .biscuit2', { x: 200, opacity: 0 });
            gsap.set('#signUpError_btn', { opacity: 0 });
            gsap.fromTo(
              '#error_scr > .appContainer',
              { scale: 0.2, opacity: 0 },
              { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
            );
            setTimeout(() => {
              // Animate to final position and full opacity
              gsap.to('#error_scr .biscuit1', {
                x: 0,
                opacity: 1,
                duration: 1,
                ease: 'power3.out',
              });

              gsap.to('#error_scr .biscuit2', {
                x: 0,
                opacity: 1,
                duration: 1,
                ease: 'power3.out',
                delay: 0.2,
              });
              this.events.dispatchEvent({
                type: 'ANIMATION_EVENTS',
                message: {
                  event_type: 'buttonAnimation',
                  data: {
                    selector: '#signUpError_btn',
                  },
                },
              });
            }, 1000);
          }
        },
        null,
        {
          name: Global.name,
          country: Global.country,
          mobile: Global.mobile,
          email: Global.email,
          pack: Global.pack,
          uid: Global.U_ID,
          utm_term,
          utm_campaign,
          utm_medium,
          utm_source,
          utm_content,
          ga_cid,

          htk: window.htk,
          checkbox: this.checkboxBool2 ? 'true' : 'false',
          //   selectedType: Global.selectedType,
          saveType: 'registerUser',
        },
        'POST',
        null,
        false
      );

      //   this.events.dispatchEvent({
      //     type: 'LOADER_EVENTS',
      //     message: {
      //       event_type: 'switch_page',
      //       data: {
      //         screenKey: 'Score',
      //       },
      //     },
      //   });
    }

    function showError(msg) {
      document.querySelector('#error').innerHTML = msg;
      document.querySelector('#error').classList.add('active');
    }
  }

  onCheckboxClick() {
    const checkbox = document.getElementById('checkbox');
    this.checkboxBool = !this.checkboxBool;
    checkbox.src = this.checkboxBool ? chckWithTick : chckWithoutTick;
  }

  onCheckboxClick2() {
    const checkbox = document.getElementById('checkbox2');
    this.checkboxBool2 = !this.checkboxBool2;
    checkbox.src = this.checkboxBool2 ? chckWithTick : chckWithoutTick;
  }

  onCheckboxClick3() {
    const checkbox = document.getElementById('checkbox3');
    this.checkboxBool3 = !this.checkboxBool3;
    checkbox.src = this.checkboxBool3 ? chckWithTick : chckWithoutTick;
  }
}
